import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Signin from './Signin';
import Signup from './Signup';

const AuthPopup = ({ showAuth, setShowAuth, setCurrentUser, setError, socket }) => {
    const [form, setForm] = useState('Sign In');

    const handleClose = () => setShowAuth(false);

    return (
        <Dialog open={showAuth} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>WB4GBI Repeater System</DialogTitle>
            <Tabs value={form} onChange={(e, value) => setForm(value)} variant="fullWidth" sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tab label="Sign In" value="Sign In" />
                <Tab label="Sign Up" value="Sign Up" />
            </Tabs>
            <DialogContent>
                {form === 'Sign In' ? (
                    <Signin
                        handleClose={handleClose}
                        setCurrentUser={setCurrentUser}
                        setError={setError}
                        setShowAuth={setShowAuth}
                        socket={socket}
                    />
                ) : (
                    <Signup
                        handleClose={handleClose}
                        setCurrentUser={setCurrentUser}
                        setError={setError}
                        setShowAuth={setShowAuth}
                        socket={socket}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default AuthPopup;
